<template>
    <div id="apricationDD">
        <div class="headerp-div">
            <div class="header-div">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="header-div" style="text-align: right">
                <div style="float: right">
                    <el-button size="mini" @click="handleCurrentChange()"
                               style="background-color:#409EFF;color: white;margin-right: 5px;">
                        刷新<i class="el-icon-search"></i>
                    </el-button>
                </div>
                <div style="float: right">
                    <el-button size="mini" type="warning" @click="downloadedFile()" style="margin-right: 5px;margin-left: 5px;">
                        导出<i class="el-icon-download"></i></el-button>
                </div>
                <div style="float: right">
                    <el-date-picker
                            @change="handleCurrentChange"
                            v-model="zqDate"
                            type="month"
                            size="mini"
                            format="yyyy年MM月"
                            value-format="yyyy-MM"
                            placeholder="选择账期"
                            :picker-options="pickerOptions">
                    </el-date-picker>
                </div>
            </div>
        </div>

        <el-table
                @cell-mouse-enter="handleMouseEnter"
                @cell-mouse-leave="handleMouseLeave"
                :data="tableData"
                height="529"
                border
                size="mini"
                style="width: 100%;">
            <el-table-column
                    width="689"
                    prop="col1"
                    label="项目"
                    align="left">
                <template slot-scope="scope">
                    <span :style="'margin-left:'+ scope.row.col1LeftPx +'px'">{{scope.row.col1}}</span>
                    <a @click="handleFormula(scope.row.col1Id,scope.row.col1,scope.row.col1Type)">
                        <i v-if="scope.row.col2 > 0" class="el-icon-edit-outline" style="display: none;margin-left: 10px;cursor: pointer"></i>
                    </a>
                </template>
            </el-table-column>
            <el-table-column
                    prop="col2"
                    width="160"
                    label="行次"
                    align="center">
            </el-table-column>
            <el-table-column
                    class-name="ricss"
                    prop="col3"
                    align="right"
                    label="本期金额">
            </el-table-column>
            <el-table-column
                    class-name="ricss"
                    prop="col4"
                    align="right"
                    label="本年累计">
            </el-table-column>

        </el-table>
        <formula v-if="formulaVisible" ref="formula"></formula>
        <formula2 v-if="formulaVisible2" ref="formula2"></formula2>
    </div>
</template>
<script>
    import Formula from '../reportStatisticalFormula/list'
    import Formula2 from '../reportStatisticalFormula/list2'
    export default {
        name: 'kmyebiaoList',
        components: {
            Formula,
            Formula2
        },
        data() {
            return {
                tableData: [],
                zqDate: null,
                formulaVisible: false,
                formulaVisible2: false,
                pickerOptions: {
                    shortcuts: [{
                        text: '本期',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '上一期',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth();
                            picker.$emit('pick', new Date(year, month - 1, 1));
                        }
                    }]
                }
            }
        },
        methods: {
            handleCurrentChange() {
                this.tableData = [];
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/report/lrb?td=' + new Date()),
                    method: 'get',
                    params: {
                        'zqDate': this.zqDate
                    }
                }).then(r => {
                    if (r.data.code == 0) {
                        this.tableData = r.data.data.dataList;
                        this.zqDate = r.data.data.zqDate;
                    } else {
                        this.$message({
                            type: 'error',
                            message: r.data.msg
                        })
                    }
                }).finally(r => {
                })

            },
            // 鼠标进入单元格
            handleMouseEnter(row, column, cell, event) {
                $(event.currentTarget).find(".el-icon-edit-outline").show();
            },
            // 鼠标离开
            handleMouseLeave(row, column, cell, event) {
                $(event.currentTarget).find(".el-icon-edit-outline").hide();
            },
            handleFormula(itemId,itemName,type) {
                let reportCode = 'report_lrb';
                //统计方式代码 1:库表统计 2:算数统计
                if(type=='1'){
                    this.formulaVisible = true;
                    this.$nextTick(() => {
                        this.$refs.formula.int(itemId,reportCode,itemName,this.zqDate);
                    })
                }else{
                    this.formulaVisible2 = true;
                    this.$nextTick(() => {
                        this.$refs.formula2.int(itemId,reportCode,itemName);
                    })
                }

            },
            downloadedFile(){

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/report/lrb?td=' + new Date()),
                    method: 'get',
                    responseType:'blob',   //返回类型
                    params: {
                        'zqDate': this.zqDate,
                        'blob': "true"
                    }
                }).then(data => {

                    //通过返回的二进制流创建 Blob对象
                    let blob = new Blob([data.data],
                        {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
                    );
                    let url = window.URL.createObjectURL(blob);
                    //方式一：该url就是由返回的二进制流创建的文件下载地址，可以直接使用 window.location.href = url;下载
                    //不过下载后需要手动修改文件名和后缀名

                    //方式二：触发浏览器的内置下载功能
                    let a = document.createElement('a')//创建一个a标签元素
                    a.style.display = 'none'//设置为不显示
                    a.href = url    //设置a标签的href属性
                    a.setAttribute('download', '利润表('+this.zqDate+').xlsx')//设置下载的文件名
                    document.body.appendChild(a)//将a标签元素加入到页面中
                    a.click()//触发点击
                    document.body.removeChild(a) // 下载完成移除元素
                    window.URL.revokeObjectURL(url) // 释放掉blob对象

                }).finally(r => {
                })
            }
        },
        created: function () {
            this.handleCurrentChange();
        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 5px;
        float: left;
        width: 50%;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 200px;
    }

    .el-collapse-item div {
        padding-left: 20px;
        padding-bottom: 15px;
    }

    #apricationDD >>> .el-table--border td, .el-table--border th {
        border-right: 1px solid #ddd !important;
    }

    #apricationDD >>> .el-table--border th {
        border-right: 1px solid #ddd !important;
        border-top: 1px solid #ddd !important;
    }

    #apricationDD >>> .el-table td, .el-table th.is-leaf {
        border-bottom: 1px solid #ddd !important;
    }

    #apricationDD >>> .el-table th.is-leaf {
        border-bottom: 1px solid #ddd !important;
    }

    #apricationDD >>> .el-table {
        border-right: 1px solid #ddd !important;
        border-left: 1px solid #ddd !important;
    }

    .queryPzDate {
        margin-right: 5px;
    }

    #apricationDD >>> tbody .ricss {
        text-align: right !important;
    }

    .kmdmCss {
        color: #3cbaff;cursor: pointer;
    }
    #apricationDD >>> .el-table tr:hover {
        text-decoration:underline;
        text-decoration-color: #78848b;
    }
</style>